import { VettingSireReport } from "./vetting.models"

export interface SireReportTemplate {
    templateType: number
    templateVersion: number
    chapters: Chapter[]
}

export interface Chapter {
    chapterId: string
    chapterNumber: number
    chapterName: string
    sections: Section[]
}

export interface Section {
    sectionId: string
    sectionNumber: number
    sectionName: string
    questions: TemplateQuestion[]
}

export interface TemplateQuestion {
    questionId: string
    questionNumber: number
    questionText: string
    shortenedQuestionText: string
    humanResponse: number
    processResponse: number
    equipmentResponse: number
    isPhotoValidation: boolean
    linkedCertificateTypeIds: string[]
    linkedPhotoLocationIds: string[]
    no: string;
    levelRisk_3: string;
    levelRisk_5: string;
    riskScore: number;
    highlighted: boolean;
}

export interface Sire2ReportResponse {
    vettingSireReport: VettingSireReport;
    viq: SireReport[];
}

export interface SireReport {
    inspectionId: string
    inspectionDate: string
    inspectionStatus: number
    inspectionCompletion: number
    publicationDate: string
    vesselOcimfId: string
    vesselPrimaryIdType: string
    vesselPrimaryIdValue: string
    templateType: number
    templateVersion: number
    reportName: string
    isCameraDisabled: boolean
    bookingCode: string
    operatorOrgId: string
    submitterOrgId: string
    inspectorOrgId: any
    tankerOperation: number
    tankerProducts: number[]
    transactionValue: any
    utcOffset: string
    metaData: MetaDaum[]
    initialOperatorComments: InitialOperatorComment[]
    subsequentOperatorComments: any[]
    questions: Question[]
}

export interface MetaDaum {
    key: string
    value?: string
}

export interface InitialOperatorComment {
    comments: string
    commentDate: string
}

export interface Question {
    templateQuestionId: string
    complexResponses: ComplexResponse[]
    inspectorPhotos: any[]
    preInspectionContent: PreInspectionContent
}

export interface ComplexResponse {
    category: number
    subjectLookupId?: string
    notAnswerableResponse: boolean
    binaryResponse?: boolean
    graduatedResponse?: number
    comments?: string
    observations: Observation[]
    positivePif?: PositivePif
}

export interface Observation {
    subjectLookupId: string
    natureOfConcernLookupId: string
    comments: string
    initialOperatorComments: any[]
    initialOperatorAttachments: any[]
    subsequentOperatorComments: any[]
    subsequentOperatorAttachments: any[]
    inspectorPhotos: any[]
}

export interface PositivePif {
    comments: string
    natureOfConcernLookupIds: string[]
    inspectorPhotos: any[]
}

export interface PreInspectionContent {
    questionnaireData: QuestionnaireDaum[]
    operatorPhotos: OperatorPhoto[]
    certificates: Certificate[]
}

export interface QuestionnaireDaum {
    source: number
    questionNumber: string
    controlNumber: any
    responseValue: string
}

export interface OperatorPhoto {
    photoId?: string
    locationId: string
    notFitted: boolean
}

export interface Certificate {
    typeId: string
    name: string
}

export enum SireReportCategories {
    None = 0,
    Hardware = 1,
    Process = 2,
    Human = 3
}